import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { API } from 'app/services';
import { useAsyncTask, useRouter } from 'app/utils';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { DocumentDetailComp_Others, DocumentDetailComp } from './components';

const useStyles = makeStyles(({ palette, breakpoints, spacing }) => ({
  root: {
    padding: spacing(3, 3, 8),
    [breakpoints.down('xs')]: {
      padding: spacing(1, 1, 3),
    },
    '@media print': {
      paddingTop: 0,
    },
  },
}));

function Detail(props) {
  const classes = useStyles();
  const { routeType = 'account', documentResult, onBack, onNext } = props;
  const router = useRouter();
  const access = useSelector((state) => state.profile.access);
  const { match } = router;
  const { params } = match;
  const [runLoadDocument] = useAsyncTask('getDocument');
  const { enqueueSnackbar } = useSnackbar();
  const [documentData, setDocumentData] = useState(null);

  const doc_id = params.document_id || documentResult?.model?.id;

  useEffect(() => {
    if (access && access.token) getDocumentDetail();
  }, [access]);

  const getDocumentDetail = () => {
    if (!doc_id) return enqueueSnackbar('invalid id', { variant: 'error' });
    runLoadDocument(async () => {
      const loader = routeType === 'account' ? API.Screening.get_document : API.Admin.get_verify_detail;
      const { model } = await loader(doc_id);
      setDocumentData(model);
    });
  };

  if (!documentData) return null;

  const isRegtank = documentData.verification_request.regtank_id ? true : false;

  return isRegtank ? <DocumentDetailComp {...props} documentData={documentData} /> : <DocumentDetailComp_Others {...props} documentData={documentData} />;
}

export default Detail;
